/* eslint-disable no-underscore-dangle */
import React from 'react';
import { useParams } from 'react-router-dom';

import { BaseHelpCenterProps } from '../types';
import { HelpCenterBreadcrumbs } from '../Navigation/HelpCenterBreadcrumbs';
import { PortableTextRenderer } from '../PortableTextRenderer';

export function ArticleView({ helpCenterData }: BaseHelpCenterProps) {
  const { sectionTitle, articleId, userId } = useParams<{
    sectionTitle: string;
    articleId: string;
    userId: string;
  }>();

  const currentSection = helpCenterData?.sections.find(
    (s) => s.title.toLowerCase() === sectionTitle?.toLowerCase(),
  );

  const currentArticle = currentSection?.articles.find(
    (a) => a._id === articleId,
  );

  if (!currentArticle) return null;

  return (
    <div className="max-w-[680px] px-4 sm:px-2 md:px-0 mb-8 md:mb-16">
      <HelpCenterBreadcrumbs helpCenterData={helpCenterData} />

      <div className="flex justify-between items-start">
        <div className="w-full">
          <h1 className="text-2xl md:text-4xl font-medium mb-1 md:mb-2">
            {currentArticle.title}
          </h1>
          <p className="text-base md:text-lg nu-text-base-disabled mb-4 md:mb-8">
            {currentArticle.description}
          </p>
          <div className="prose max-w-none text-xsm nu-text-base-secondary">
            <PortableTextRenderer
              value={currentArticle.content}
              userId={userId}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
